import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const CONSULTATION_URL = 'https://myriadsystems.ai/contact';

const SERVICE_CONFIG = {
  vom: {
    title: 'Improve your front-office with Virtual Office Manager',
    description:
      "You're currently not using the Virtual Office Manager service. Enable it to streamline front-office workflows, improve scheduling, and reduce manual work across your practice.",
    linkText: 'Request Virtual Office Manager services'
  },
  medbill: {
    title: 'Simplify your billing with MedBill',
    description:
      "You're currently not using MedBill's built-in biller service. Enable it to streamline billing workflows, reduce errors, and save time across your practice.",
    linkText: 'Request Medbill services'
  },
  both: {
    title: 'Run your practice more efficiently',
    bullets: [
      "MedBill's Built-in Biller Service to simplify billing operations.",
      'The Virtual Office Manager Service to strengthen your front-office workflows.'
    ],
    linkText: 'Submit a consultation request'
  }
};

const ServiceSuggestionBanner = ({ service }) => {
  const config = SERVICE_CONFIG[service];

  if (!config) return null;

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <Icon icon="motion-terms-4" />
      <h3 className="mt-4 text-base font-semibold text-neutral-900">{config.title}</h3>
      {config.bullets ? (
        <div className="mt-2 text-center text-sm text-neutral-600">
          <p>To get started, you can request:</p>
          <ul className="mt-1 list-inside list-disc">
            {config.bullets.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="mt-2 max-w-md text-center text-sm text-neutral-600">{config.description}</p>
      )}
      <div className="mt-4">
        <Button
          variant="link"
          text={config.linkText}
          icon="send-2-filled"
          onClick={() => window.open(CONSULTATION_URL, '_blank', 'noopener,noreferrer')}
        />
      </div>
    </div>
  );
};

export default ServiceSuggestionBanner;
